/** Supabase `projects` tablosuyla eşleşen tip tanımı */
export interface Project {
  id: string;
  user_id: string;
  title: string;
  description: string | null;
  thumbnail_url: string | null;
  status: 'active' | 'completed' | 'archived';
  created_at: string;
  updated_at: string;
}

export interface TeamMember {
  id: string;
  project_id: string;
  full_name: string;
  email: string | null;
  phone: string | null;
  role: string | null;
  category: 'takım' | 'tedarikçi' | 'bilirkişi' | 'müşteri';
  created_at: string;
}

/** Durum etiket/renk haritası — Badge gösterimi için */
export const statusLabels: Record<string, { label: string; color: string; bg: string }> = {
  active:    { label: 'Aktif',      color: 'text-emerald-700', bg: 'bg-emerald-50' },
  completed: { label: 'Tamamlandı', color: 'text-blue-700',    bg: 'bg-blue-50'    },
  archived:  { label: 'Arşivlendi', color: 'text-stone-500',   bg: 'bg-stone-100'  },
};

/** Select/filter bileşenleri için durum seçenekleri */
export const statusOptions: { value: Project['status']; label: string }[] = [
  { value: 'active',    label: 'Aktif'      },
  { value: 'completed', label: 'Tamamlandı' },
  { value: 'archived',  label: 'Arşivlendi' },
];
